import { createContext, useContext, useState, ReactNode } from 'react';

interface IDealTooltipContext {
  dealTooltipOpened: string | null,
  setDealTooltipOpened: (dealId: string | null) => void,
}

const useDealTooltip = () => {
    const [dealTooltipOpened, setDealTooltipOpened] = useState<string | null>(null);

    return { dealTooltipOpened, setDealTooltipOpened };
};

const DealTooltipContext = createContext<IDealTooltipContext | undefined>(undefined);

export const DealTooltipProvider = ({ children }: { children: ReactNode }) => {
  const { dealTooltipOpened, setDealTooltipOpened } = useDealTooltip();

  return (
    <DealTooltipContext.Provider value={ { dealTooltipOpened, setDealTooltipOpened } }>
      { children }
    </DealTooltipContext.Provider>
  );
};

export const useDealTooltipContext = () => {
  const context = useContext(DealTooltipContext);
  if (!context) {
    throw new Error('useDealTooltipContext must be used within a DealTooltipProvider');
  }
  return context;
};
